import {Step} from 'react-joyride';
import {tourText} from '../../texts/dashboardText';
import {stepConfig} from './dashboardStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getDashboardSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Dashboard');
